export const deriveSearchByFromQuery = (query: string): "keyword" | "gtid" => {
  // Support legacy/new GTID-like formats such as `A-1234`, `AB-1234`, `PN-GYDXSR`.
  const normalized = query.trim().toUpperCase();
  const isGtidLike = /^[A-Z0-9]+(?:-[A-Z0-9]+)+$/.test(normalized);
  return isGtidLike ? "gtid" : "keyword";
};
